var freshChat = (function() {
  var freshchatId = "",
      ga_id = Cookie.read("_ga"),
      externalId = "",
      customWidget = FreshChatConfig.customWidgetChat.visible ? FreshChatConfig.customWidgetChat.visible : FreshChatConfig.customWidgetValue,
      customWidgetContainer = document.getElementById("custom-fc-frame"),
      timeOut,
      freshChatBubble = document.getElementById("freshchat-bubble"),
      freshChatBubbleTxt = document.getElementById("freshchat-bubble--text"),
      freshChatBubbleCancel = document.getElementById("freshchat-bubble--cancel"),
      channelName = FreshChatConfig.tags.length === 1 ? FreshChatConfig.tags[0] : "multiple_channels",
      homePage = document.getElementById("home-page");
    if (ga_id) {
      ga_id = ga_id.split(".");
      if (ga_id.length >= 4) {
        externalId = ga_id[2] + ga_id[3];
      }
    }
    
    //Enable source for the freshchat email overlay experiment, as the experiment is all WP pages except homepage
    if (FreshChatConfig.vwoShow && FreshChatConfig.bs_freshchat_email_experiment) {
      homePage = true;
    }
  
  function setChannel(chn) {
    channelName = chn;
  }

  function initFreshChat() {
    channelName = FreshChatConfig.tags.length === 1 ? FreshChatConfig.tags[0] : "multiple_channels";
    if (typeof window.fcWidget.isInitialized() === 'boolean' && window.fcWidget.isInitialized()) {
      if (customWidget) {
        if (customWidgetContainer) {
          customWidgetContainer.classList.remove('hide');
        }
        // load chat bubble message
        if (FreshChatConfig.chatBubble.visible && freshChatBubbleTxt) {
          freshChatBubbleTxt.innerHTML = FreshChatConfig.chatBubble.text;
          timeOut = setTimeout(invokeChatBubbleOption, FreshChatConfig.chatBubble.timer);
        }
      }
      //show images from lazy load
      lazyLoading.show();
      return;
    }
    window.fcWidget.init({
      token: FreshChatConfig.api,
      host: FreshChatConfig.host,
      tags: FreshChatConfig.tags,
      externalId : externalId,
      config: {
        headerProperty: {
          hideChatButton: customWidget,
          backgroundColor: '#0070f0'
        }
      }
    });
    setEvents();

    if (customWidget) {
      // check cookie condition to autopopup chat on load if user has opened chat prev
      if (Cookie.read(stage_env_cookie_prefix + 'bs_freshchat_open_status') === '1' && FreshChatConfig.bs_freshchat_auto_open_experiment) {
        window.fcWidget.open();
      } else {
        if (customWidgetContainer) {
          customWidgetContainer.classList.remove('hide');
        }
        // load chat bubble message
        if (FreshChatConfig.chatBubble.visible && freshChatBubbleTxt) {
          freshChatBubbleTxt.innerHTML = FreshChatConfig.chatBubble.text;
          timeOut = setTimeout(invokeChatBubbleOption, FreshChatConfig.chatBubble.timer);
        }
      }
    }

    //show images from lazy load
    lazyLoading.show();
  }
  function setEvents() {
    // Widget load event
    window.fcWidget.on("widget:loaded", function() {
      window.hasOwnProperty("WebEventTracker") ? WebEventTracker.logEvent(EDS.webEvents, "FreshChat", bsLib.extend({
        freshchatId: freshchatId,
        userId: externalId,
        action: "WidgetLoaded",
        channel: channelName
      },
      ((popUpCSFOptions.vwoShow && homePage) ? {source:popUpCSFOptions.source} : { source: FreshChatConfig.bs_freshchat_dg_email_experiment ? 'chat_for_DG_Comp_visitors' : ''})
      )) : "";
    });
    var source = "user_click",
      logMessageEvent = false;
    window.fcWidget.on("message:sent", function() {
      if (logMessageEvent) {
        window.hasOwnProperty("WebEventTracker") ? WebEventTracker.logEvent(EDS.webEvents, "FreshChat", bsLib.extend({
          widgetOpen: true,
          conversationCreated: true,
          action: "ConversationCreated",
          userId: externalId,
          freshchatId: freshchatId,
          newUser: false,
          channel: channelName
        },
        ((popUpCSFOptions.vwoShow && homePage) ? {source:popUpCSFOptions.source} : { source: FreshChatConfig.bs_freshchat_dg_email_experiment ? 'chat_for_DG_Comp_visitors' : ''})
        )) : "";
        logMessageEvent = false;
        Cookie.create(stage_env_cookie_prefix + 'bs_freshchat_chat_initiated', FreshChatConfig.tags.toString(), 1);
      }
    });

    window.fcWidget.on("widget:opened", function(resp) {
      if ((Cookie.read(stage_env_cookie_prefix + 'bs_freshchat_open_status') === '0' || Cookie.read(stage_env_cookie_prefix + 'bs_freshchat_open_status') === null) && FreshChatConfig.bs_freshchat_auto_open_experiment) {
        Cookie.create(stage_env_cookie_prefix + 'bs_freshchat_open_status', '1', 1);
      }
      if (freshChatBubble) {
        freshChatBubble.classList.add("hide");
      }

      //Create overlay document
      if ((Cookie.read(stage_env_cookie_prefix + 'fc_email_overlay_submitted') !== '1' && !wpUserLoggedIn && FreshChatConfig.bs_freshchat_email_experiment) || (FreshChatConfig.bs_freshchat_dg_email_experiment && Cookie.read(stage_env_cookie_prefix + 'fc_email_dg_overlay_submitted') !== '1') )
        {
          var fcFrame = document.getElementById("fc_frame"),
          fcOverlay = document.getElementById("fc-overlay"),
          fcOverlayVisibility = window.getComputedStyle(fcOverlay);
        
        if (fcFrame && fcOverlay) {
          var fcFrameVisibility = window.getComputedStyle(fcFrame);
          if (parseFloat(fcFrameVisibility.opacity) > 0) {
            fcOverlay.remove();
            fcFrame.appendChild(fcOverlay);
          }

          var emailField = document.querySelector('.fc-overlay #fc-overlay-email'),
            emailNotifyMsg = document.querySelector('.fc-overlay #email-notify-msg');
    
          if (emailField) {
            setInterval(function () {
              var currentFocusedElement = document.activeElement;
              if (fcFrame.classList.contains('fc-open') && currentFocusedElement.id == 'fc_widget' && fcOverlayVisibility.display !== 'none') {
                emailField.focus();
                var emailError = document.querySelector('.fc-overlay #error-email-span');
                if (emailError) {
                  emailError.remove();
                  emailField.classList.remove('error-border');
                  emailNotifyMsg.classList.remove('hide');
                }
              }
            }, 500);
          }

          WebEventTracker.logEvent(
            EDS.webEvents,
            'FreshChat',
            bsLib.extend(
              {
                action: 'WidgetOpened_with_email_field'
              },
              popUpCSFOptions.vwoShow ? { source: popUpCSFOptions.source } : { source: FreshChatConfig.bs_freshchat_dg_email_experiment ? 'chat_for_DG_Comp_visitors' : ''}
            )
          );
        }
      }
  
      // Once widget is open, don't open again on scroll
      logMessageEvent = true;
      if (customWidget && customWidgetContainer) {
        customWidgetContainer.classList.add('hide');
      }
      window.fcWidget.on("user:created", function(resp) {
        if (resp.success == true) {    
          window.hasOwnProperty("WebEventTracker") ? WebEventTracker.logEvent(EDS.webEvents, "FreshChat", bsLib.extend({
            widgetOpen: true,
            conversationCreated: true,
            action: "ConversationCreated",
            userId: externalId,
            freshchatId: freshchatId,
            newUser: true,
            channel: channelName
          },
          ((popUpCSFOptions.vwoShow && homePage) ? {source:popUpCSFOptions.source} : {})
          )) : "";
          logMessageEvent = false;
        }
      });

      //Disabling this event for the freshchat emailoverlay experiment
      if (!FreshChatConfig.vwoShow && ( !FreshChatConfig.bs_freshchat_email_experiment || !FreshChatConfig.bs_freshchat_dg_email_experiment ) ) {
        window.hasOwnProperty("WebEventTracker") ? WebEventTracker.logEvent(EDS.webEvents, "FreshChat", bsLib.extend({
          widgetOpen: true,
          action: "WidgetOpened",
          userId: externalId,
          freshchatId: freshchatId,
          channel: channelName
        },
          ((popUpCSFOptions.vwoShow && homePage) ? { source: popUpCSFOptions.source } : { source: source })
        )) : "";
        source = "user_click"; // doing this because the widget cannot be opened via timer or scroll for the second time.
      }
    });
    window.fcWidget.on("widget:closed", function(resp) {
      window.hasOwnProperty("WebEventTracker") ? WebEventTracker.logEvent(EDS.webEvents, "FreshChat", bsLib.extend({
        widgetClosed: true,
        action: "WidgetClosed",
        userId: externalId,
        freshchatId: freshchatId,
        channel: channelName
      },
      ((popUpCSFOptions.vwoShow && homePage) ? {source:popUpCSFOptions.source} : { source: FreshChatConfig.bs_freshchat_dg_email_experiment ? 'chat_for_DG_Comp_visitors' : ''})
      )) : "";

      // For the DG freshchat emailoverlay experiment reset captcha on the page.
      if( FreshChatConfig.bs_freshchat_dg_email_experiment && Cookie.read(stage_env_cookie_prefix + 'fc_email_dg_overlay_submitted') !== '1' ) { 
        if (typeof grecaptcha !== 'undefined') {  
          grecaptcha.reset();
        }
      }
      if ((Cookie.read(stage_env_cookie_prefix + 'fc_email_overlay_submitted') !== '1' && !wpUserLoggedIn && FreshChatConfig.bs_freshchat_email_experiment) || (FreshChatConfig.bs_freshchat_dg_email_experiment && Cookie.read(stage_env_cookie_prefix + 'fc_email_dg_overlay_submitted') !== '1') )
      {
        var emailField = document.querySelector('.fc-overlay #fc-overlay-email');
        if (emailField) {  
          var emailError = document.querySelector('.fc-overlay #error-email-span'),
            emailNotifyMsg = document.querySelector('.fc-overlay #email-notify-msg');
            
            if (emailError) {
              emailError.remove();
              emailField.classList.remove('error-border');
              emailNotifyMsg.classList.remove('hide');
            }
        }
      }

      if (customWidget) {
        if (Cookie.read(stage_env_cookie_prefix + 'bs_freshchat_open_status') === '1' && FreshChatConfig.bs_freshchat_auto_open_experiment) {
          Cookie.create(stage_env_cookie_prefix + 'bs_freshchat_open_status', '0', 1);
        }
        if (customWidgetContainer) {
          customWidgetContainer.classList.remove('hide');
        }
        //show images from lazy load
        lazyLoading.show();
      }
      if (FreshChatConfig.chatBubble.visible && freshChatBubbleTxt) {
        freshChatBubbleTxt.innerHTML = FreshChatConfig.chatBubble.text;
        timeOut = setTimeout(invokeChatBubbleOption, FreshChatConfig.chatBubble.timer);
        //webtracker event
        window.hasOwnProperty("WebEventTracker") ? WebEventTracker.logEvent(EDS.webEvents, "FreshChat", bsLib.extend({
          action: 'PopUpTextLoaded',
          channel: channelName
        },
        ((popUpCSFOptions.vwoShow && homePage) ? {source:popUpCSFOptions.source} : {})
        )) : "";
        
        window.addEventListener(
          "click",
          function(event) {
            if (event.target.classList.contains("freshchat-bubble") || event.target.classList.contains("freshchat-bubble--text")) {
              freshChatBubble.classList.add("hide");
              window.fcWidget.open();
            }
            clearTimeout(timeOut);
          },
          false
        );
      }
    });
    if (customWidgetContainer) {
      customWidgetContainer.addEventListener("click", function() {
        window.fcWidget.open();
      });
    }
    if (freshChatBubbleCancel) {
      freshChatBubbleCancel.addEventListener(
        "click",
        function(event) {
          freshChatBubble.classList.add("hide");
          //webtracker event
          window.hasOwnProperty("WebEventTracker") ? WebEventTracker.logEvent(EDS.webEvents, "FreshChat", bsLib.extend({
            action: 'PopUpTextClosed',
            channel: channelName
          },
          ((popUpCSFOptions.vwoShow && homePage) ? {source:popUpCSFOptions.source} : {})
          )) : "";
        },
        false
      );
    }
  }
  function invokeChatBubbleOption() {
    if (!window.fcWidget.isOpen()) {
      freshChatBubble.classList.remove("hide");
    }
  }
  function checkWorkingHours() {
    var getCurrentTime = new Date(),
      getWorkingOpenTime = new Date(),
      getWorkingCloseTime = new Date(),
      start = FreshChatConfig.startWorkingHours.split(":"),
      end = FreshChatConfig.endWorkingHours.split(":");
    //Set UTC default time 9:30
    getWorkingOpenTime.setUTCHours(start[0]);
    getWorkingOpenTime.setUTCMinutes(start[1]);
    getWorkingOpenTime.setUTCSeconds(start[2]);
    //Set UTC default time 21:30
    getWorkingCloseTime.setUTCHours(end[0]);
    getWorkingCloseTime.setUTCMinutes(end[1]);
    getWorkingCloseTime.setUTCSeconds(end[2]);
    //Check working hours time
    if (
      getCurrentTime > getWorkingOpenTime &&
      getCurrentTime < getWorkingCloseTime &&
      getCurrentTime.getDay() > 0 && //Sunday
      getCurrentTime.getDay() < 6 //Saturday
    ) {
      return true;
    } else {
      return false;
    }
  }
  function loadChat() {
    var e,
      i = document,
      t = "freshchat-js-sdk",
      openFreshChat = Cookie.read(FreshChatConfig.cookieName),
      chat_initiated_on = Cookie.read(stage_env_cookie_prefix + 'bs_freshchat_chat_initiated');
    if (!i.getElementById(t) 
      && chat_initiated_on === null
      && openFreshChat === null) {
      (((e = i.createElement("script")).id = t),
      (e.async = !0),
      (e.src = "https://wchat.freshchat.com/js/widget.js"),
      i.head.appendChild(e));
    }
  }
  function show() {
    var e,
      i = document,
      t = "freshchat-js-sdk";
    i.getElementById(t)
      ? initFreshChat()
      : (((e = i.createElement("script")).id = t),
        (e.async = !0),
        (e.src = "https://wchat.freshchat.com/js/widget.js"),
        (e.onload = initFreshChat),
        i.head.appendChild(e));
  }
  // Set chat position based on cookie band
  function setFreshChatPosition() {
    var cookieApproved = Cookie.read(stage_env_cookie_prefix + 'UserOptCookie')
        consentCookie =  document.getElementById("consent-banner"),
      guideFloatingBanner = document.getElementById('guide-floating-banner'),
      hideFloatingBanner = Cookie.read("hideFloatingBanner");
    // check guide page floating banner else normal cookie band
    if (guideFloatingBanner && window.innerWidth <= 1024 && hideFloatingBanner === null) {
      if (cookieApproved === null && !enableTrustArcCCM) {
        customWidgetContainer ? customWidgetContainer.style.bottom = '200px' : '';
        freshChatBubble ? freshChatBubble.style.bottom = '275px' : '';
      } else {
        customWidgetContainer ? customWidgetContainer.style.bottom = '110px' : '';
        freshChatBubble ? freshChatBubble.style.bottom = '185px' : '';
      }
    } else if (cookieApproved === null && !enableTrustArcCCM) {
      customWidgetContainer ? customWidgetContainer.classList.add("custom-chat-wrapper") : '';
      freshChatBubble ? freshChatBubble.classList.add("custom-bubble-wrapper") : '';
    } else if (enableTrustArcCCM && !wpUserLoggedIn && consentCookie && consentCookie.children.length !== 0) {
      customWidgetContainer ? customWidgetContainer.classList.add("custom-chat-wrapper") : '';
      freshChatBubble ? freshChatBubble.classList.add("custom-bubble-wrapper") : '';
    } else {
      customWidgetContainer ? customWidgetContainer.classList.remove("custom-chat-wrapper") : '';
      freshChatBubble ? freshChatBubble.classList.remove("custom-bubble-wrapper") : '';
      (customWidgetContainer && !homePage) ? customWidgetContainer.removeAttribute('style') : '';
      (freshChatBubble && !homePage) ? freshChatBubble.removeAttribute('style') : '';
    }
  }
  function init(onLoad) {
    if (onLoad === undefined) {
      onLoad = true;
    }
    var openFreshChat = Cookie.read(FreshChatConfig.cookieName),
      chat_initiated_on = Cookie.read(stage_env_cookie_prefix + 'bs_freshchat_chat_initiated'),
      bs_chat_channels = Cookie.read(stage_env_cookie_prefix + 'bs_chat_channels');
    //update freshchat channel
    if (chat_initiated_on && chat_initiated_on != '1') {
      openFreshChat = 1;
      FreshChatConfig.tags = chat_initiated_on.split(",");
    } else if (FreshChatConfig.cookieName === stage_env_cookie_prefix + "show_freshchat" && openFreshChat === "2") {
      if (bs_chat_channels) {
        FreshChatConfig.tags = bs_chat_channels.split(",");
      }
      openFreshChat = 1;
    }
    setFreshChatPosition();
    //disable content freshchat if not working hours
    if (!checkWorkingHours()) {
      var openFreshchatBtn = document.querySelectorAll(".open-freshchat-widget, .freshchat-widget-working-hours");
      if (!FreshChatConfig.enableFreshChatFullTime) { // condition to enable freshchat for full time even after working hrs
        for (var j = 0; j < openFreshchatBtn.length; j++) {
          openFreshchatBtn[j].classList.add("hide", "hide-xl", "hide-lg", "hide-md", "hide-sm", "hide-xs");
        }
      }
    }
    //check if tags parallels_page
    if (
      checkWorkingHours() &&
      FreshChatConfig.show &&
      window.innerWidth > 640 &&
      FreshChatConfig.tags.indexOf("parallels_page") !== -1 &&
      (FreshChatConfig.vwoShow == 1 ||
      (openFreshChat &&
      openFreshChat == 1))
    ) {
      onLoad ? window.addEventListener("load", show, !1) : show();
    } else if (
      checkWorkingHours() &&
      FreshChatConfig.show &&
      window.innerWidth > 640 &&
      openFreshChat &&
      openFreshChat == 1
    ) { //Check Working Hours and valid condition to load freshchat
      onLoad ? window.addEventListener("load", show, !1) : show();
    } else if (
      checkWorkingHours() &&
      FreshChatConfig.show &&
      window.innerWidth > 640 &&
      FreshChatConfig.enableFreshChatOnPage // default value is false
    ) { // initialize freshchat for individual pages based on regex
      onLoad ? window.addEventListener("load", show, !1) : show();
    } else if (
      checkWorkingHours() &&
      FreshChatConfig.show &&
      window.innerWidth > 640 &&
      FreshChatConfig.vwoShow // default value is false
    ) { // initialize freshchat for individual pages based on VWO settings
      onLoad ? window.addEventListener("load", show, !1) : show();
    }
  } 
  return {
    init: init,
    show: show,
    loadChat: loadChat,
    setChannel: setChannel,
    initFreshChat: initFreshChat,
    setFreshChatPosition: setFreshChatPosition
  };
})();
//Open Freshchat
var openFreshchatBtn = document.querySelectorAll(".open-freshchat-widget");
if (openFreshchatBtn.length > 0) {
  FreshChatConfig.chatBubble.visible = false;
  setTimeout(function() {
    freshChat.loadChat();
  }, 0);
}
var intS = 0;
for (var i = 0; i < openFreshchatBtn.length; i++) {
  openFreshchatBtn[i].addEventListener("click", function(e) {
    freshChat.show();
    var eTime = setInterval(function () {
      if (typeof window.fcWidget !== 'undefined') {
        window.fcWidget.open();
      }
      if (++intS >= 20) {
        clearInterval(eTime);
      }
    }, 100);
  });
}
//Call freshChat
window.addEventListener("load", function() {
  freshChat.init(false);
});